export const Key = <T extends string>(value: T): `byko-checkout:${T}` => `byko-checkout:${value}`;
